import { render, staticRenderFns } from "./banners.vue?vue&type=template&id=ad647a34&scoped=true&"
import script from "./banners.vue?vue&type=script&lang=js&"
export * from "./banners.vue?vue&type=script&lang=js&"
import style0 from "./banners.vue?vue&type=style&index=0&id=ad647a34&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad647a34",
  null
  
)

export default component.exports